import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'

import store from '../store'

Vue.use(Vuex, axios)

const getDetailBaseUrl = function() {
  const buildYourJewelMode = store.getters['buildYourJewel/getBuildYourJewelMode']
  return buildYourJewelMode? `${process.env.VUE_APP_BASE_URL}` + '/build-your-jewel' : `${process.env.VUE_APP_BASE_URL}`;
}

export default {
  getValues(cb, sku) {
    const credential = store.getters['config/getCredential']
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential && credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      } else if (credential.apiSecret) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
          'X-ApiSecret': credential.apiSecret,
        }
      } else if (credential && credential.apiKey) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
        }
      }
    }
    const params = new URLSearchParams();
    params.append('locale', credential?.locale)
    const buildYourJewelModeStones = store.getters['buildYourJewel/getSelectedStones'];
    params.append('diamondIds', buildYourJewelModeStones?.map(stone => stone.id).join(","))
    axios
      .get(
        getDetailBaseUrl() + `/jw/${sku}`,
        {
          params: params,
          headers: headerObj
        }
      )
      .then(res => {
        cb(res)
      })
      .catch(error => {
        console.log(error);
      })
  },
  getValuesForKit(cb, sku) {
    const credential = store.getters['config/getCredential']
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential && credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      } else if (credential.apiSecret) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
          'X-ApiSecret': credential.apiSecret,
        }
      } else if (credential && credential.apiKey) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
        }
      }
    }
    const params = new URLSearchParams();
    params.append('locale', credential?.locale);
    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/kit/${sku}`,
        {
          headers: headerObj,
          params: params
        }
      )
      .then(res => {
        cb(res)
      })
      .catch(error => {
        console.log(error);
      })
  }
}
